export default class OrderQueueSockets {
  constructor({ orderSelector }) {
    this._selector = orderSelector;

    if (orderSelector == null || orderSelector == "") {
      throw new TypeError(
        `Some arguments are empty. orderSelector: ${orderSelector}`
      );
    }
  }

  run() {
    this._initializeSockets();
  }

  _initializeSockets() {
    this._schedulePurchaseSocketsBuilder((res) => {
      if (res.action === "reload" || (res.url && res.url !== "")) {
        if (res.error && res.error !== "") {
          sessionStorage.setItem("tcFlashMessage", res.error);
        }
        if (res.action === "reload") {
          let entity_id = $("[data-entity-id]").data("entity-id");
          tc.dom.setCookie("queue_order_" + entity_id, null, { expires: new Date(0) });
          window.location.reload();
        } else {
          this._redirectAction(res.url);
        }
      } else if (res.error !== null) {
        this._handleOrderError(res.error);
      }
    });
    return this;
  }

  _schedulePurchaseSocketsBuilder(fn) {
    $("body").on("tc-prepare-for-purchase", fn.bind(this));
    this._purchaseSocketsDestructor = () => {
      $("body").off("tc-prepare-for-purchase", fn.bind(this));
    };
  }

  _handleOrderError(error) {
    if (this._redirectTimer != null) {
      window.clearTimeout(this._redirectTimer);
    }
    const orderEl = document.querySelector(this._selector);
    orderEl.setAttribute("data-message-type", "error");
    if (orderEl) {
      orderEl.innerHTML = `<div class='text-center'>${error}</div>`;
    }
    window.setTimeout(() => {
      location.reload();
    }, 5000);
  }

  _redirectAction(url) {
    window.location.href = url;
  }
}
